import React, { useEffect } from "react";
import { Card } from "@mantine/core";
import Cards from "../components/Cards.js";
import useCards from "../hooks/useCards.js";
import useAnalytics from "../hooks/useAnalytics.js";

export default function CardsRoute() {
    const { data, isLoading, isSuccess, isError } = useCards();
    const { trackEvent, AnalyticsEvents } = useAnalytics();

    // Track card display success
    useEffect(() => {
        if (isSuccess && data) {
            const hasCardData = data.front?.data || data.back?.data;
            if (hasCardData) {
                trackEvent(AnalyticsEvents.CARD_DISPLAYED_SUCCESS, {
                    has_front: !!data.front?.data,
                    has_back: !!data.back?.data,
                    has_pdf: !!data.pdf,
                    front_source: data.front?.source,
                    back_source: data.back?.source,
                });
            } else {
                // Card data loaded but no actual card images
                trackEvent(AnalyticsEvents.CARD_DISPLAYED_FAILURE, {
                    reason: "no_card_data",
                });
            }
        }
    }, [isSuccess, data, trackEvent, AnalyticsEvents]);

    // Track card display failure
    useEffect(() => {
        if (isError) {
            trackEvent(AnalyticsEvents.CARD_DISPLAYED_FAILURE, {
                reason: "api_error",
            });
        }
    }, [isError, trackEvent, AnalyticsEvents]);

    return (
        <>
            <Card shadow="sm" bg={"gray.1"} p={"lg"} m={"lg"}>
                <Cards isLoading={isLoading} data={data} />
            </Card>
        </>
    );
}
